class NWTProductPicker extends HTMLElement {
  constructor() {
    super();

    this.handleCartUpdated = this.handleCartUpdated.bind(this);
  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    console.log('---- nwt disconnect');
    this.deleteEvents();
  }

  bindEvents() {
    document.addEventListener('cart:nwt-cart-updated',this.handleCartUpdated);
  }

  deleteEvents() {
    document.removeEventListener('cart:nwt-cart-updated',this.handleCartUpdated);
  }

  handleCartUpdated(event) {
    console.log('event received', event?.detail?.originalEvent);
  }
}

customElements.define('nwt-product-picker', NWTProductPicker);